import { lazy } from 'react';

const RewardsDetail = lazy(() =>  import('../pages/Rewards/Detail'));

export default [{
    path: "/rewards",
    element: RewardsDetail,
    analytics: { name: ["Rewards"]},
}]